var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"BtnIcon Download",attrs:{"disabled":_vm.total === 0},on:{"click":_vm.exportCsv}})}
var staticRenderFns = []

export { render, staticRenderFns }